<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CustomsDeclarationInfo')"
    :width="$selectByLang('240px', '300px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('60px', '120px')" label-position="left" style="margin: 0 10px;">
      <el-form-item :label="$t('queryJob.declared')">
        <el-checkbox :value="aeJob.declareCustomsState===1" @input="value=>{aeJob.declareCustomsState=value?1:0}" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CustomsDeclaration')+$t('Message.Count')">
        <el-input-number
          v-model="aeJob.csTotal"
          :precision="0"
          :min="0"
          :max="999"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Inspection')+$t('Message.Count')">
        <el-input-number
          v-model="aeJob.checkCounts"
          :precision="0"
          :min="0"
          :max="999"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.CommodityInspection')+$t('Message.Count')">
        <el-input-number
          v-model="aeJob.ciCounts"
          :precision="0"
          :min="0"
          :max="999"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item :label="$t('queryJob.guanFeng')+$t('Message.Count')">
        <el-input-number
          v-model="aeJob.sealCounts"
          :precision="0"
          :min="0"
          :max="999"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item :label="$t('Tool.Authorize')+$t('Message.Count')">
        <el-input-number
          v-model="aeJob.authorizeCounts"
          :precision="0"
          :min="0"
          :max="999"
          controls-position="right"
        />
      </el-form-item>
      <el-form-item :label="$t('queryJob.singleCopy')+$t('Message.Count')">
        <el-input-number
          v-model="aeJob.patchUpCounts"
          :precision="0"
          :min="0"
          :max="999"
          controls-position="right"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { saveAeBookingSpace } from '@/api/AirExport/airExportJob'

export default {
  name: 'DeclareCustomsDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: null,
      aeJob: {
        declareCustomsState: 0,
        csTotal: 0,
        checkCounts: 0,
        ciCounts: 0,
        sealCounts: 0,
        authorizeCounts: 0,
        patchUpCounts: 0
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.aeJob.uuid !== this.job.uuid) {
          const newJob = { uuid: this.job.uuid }
          this.loading = getLoading4Cxt(this)
          new AirExportJob(newJob).loadJobRelated({ job: true }).then(() => {
            this.aeJob = newJob
          }).finally(() => {
            this.loading.close()
          })
        }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    clickHandler() {
      saveAeBookingSpace({ job: this.aeJob }).then(res => {
        Object.assign(this.aeJob, res.data.job)
        this.job.version = this.aeJob.version
        this.innerVisible = false
      })
    }
  }
}
</script>
